/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CardProductCardImageDetailsCardOrientation = typeof CardProductCardImageDetailsCardOrientation[keyof typeof CardProductCardImageDetailsCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardProductCardImageDetailsCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
